import RiskAssessmentModel        from 'Models/intervention/RiskAssessmentModel';
import TaskZoneModel              from 'Models/intervention/TaskZoneModel';
import VatModel                   from 'Models/invoice/VatModel';
import ActivityModel              from 'Models/sales/ActivityModel';
import ContractIterationItemModel from 'Models/sales/ContractIterationItemModel';
import doc                        from 'decorators/doc';
import model                      from 'decorators/model';
import { Timestampable }          from 'helpers/traits';
import { Blamable }               from 'helpers/traits';
import SalesPrivateApiModel       from 'modelx/models/abstracts/SalesPrivateApiModel';

@model.staticLabel('Ligne de prestation', false)
@model.urnResource('contract_iteration_item_activity')
@doc.path('/contract_iteration_item_activities/{?id}')
export default class ContractIterationItemActivityModel extends Blamable(Timestampable(SalesPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'contractIterationItem': id;
		'contractIterationItem.contractIteration': id;
		'exists[itemActivityArticles]': '0' | '1';
		'locationUrn': Urn;
		'tags[serviceUrn][tagReference]': id;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'contractIterationItem.position': string;
		'position': string;
	}> = {};

	@doc.model(ActivityModel) declare activity: ActivityModel;
	@doc.model(ContractIterationItemModel) declare contractIterationItem: ContractIterationItemModel;
	@doc.string declare label: string;
	@doc.number declare labourHourlyCost: number;
	@doc.string declare note: string;
	@doc.number declare position: number;
	@doc.number declare priceExclTax: number;
	@doc.string declare quantity: string;
	@doc.modelUrn(RiskAssessmentModel) declare riskAssessment: RiskAssessmentModel;
	@doc.number declare rawTotalPriceExclTax: number;
	@doc.number declare totalArticleCost: number;
	@doc.number declare totalArticleMargin: number;
	@doc.number declare totalArticlePrice: number;
	@doc.number declare totalLabourPrice: number;
	@doc.number declare totalPriceExclTax: number;
	@doc.number declare totalPriceInclTax: number;
	@doc.string declare vatRate: string;
	@doc.modelUrn(VatModel) declare vat: VatModel;

	@model.resolvable(TaskZoneModel, { attributeName: 'locationUrn' })
	declare location: TaskZoneModel;

	get item() {
		return this.contractIterationItem;
	}

	get isAcc() {
		return this.activity.activityType.activityCategory.reference === 'acc';
	}

	get status() {
		return this.contractIterationItem.contractIteration.contractIterationStatus;
	}
}